import blueWarningIcon from '../../../images/blue_wraning.png';
import greenWarningIcon from '../../../images/green_wraning.png';
import redWarningIcon from '../../../images/warning_red.png';
import whiteWarningIcon from '../../../images/warning_white.png';

export const ICONS = {
    blue: blueWarningIcon,
    green: greenWarningIcon,
    red: redWarningIcon,
    gray: whiteWarningIcon
};
